import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../MobileCart.css";
import Skeleton from "@material-ui/lab/Skeleton";
import { withRouter } from "react-router";

class CartBody extends Component {
  render() {
    const { classes, item } = this.props;
    return (
      <Paper className={classes.paper}>
        <div style={{ display: "flex" }}>
          {item.bookCoverUrl ? (
            <img
              src={item.bookCoverUrl}
              alt={item.title}
              style={{ width: 100, height: 100 }}
            />
          ) : (
            <Skeleton variant="rect" />
          )}
          <div style={{ marginLeft: 10, fontSize: 16, flexGrow: 1 }}>
            <div
              onClick={() =>
                this.props.history.push(`/books/details/${item.id}`)
              }
            >
              {item.title}
            </div>
            <div>{item.genre}</div>
            <div>Rs. {item.price} /-</div>
          </div>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <IconButton>
              <DeleteIcon style={{ color: "#0a1f3a" }} />
            </IconButton>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(withRouter(CartBody));
